<template>
  <div class="pb-5">
    <div class="row mb-3">
      <div class="col-6 col-md-6 col-lg-6 col-xl-4">
        <v-select
          v-model="dataId"
          :reduce="(project) => project.id"
          aria-label="Seleccionar Proyecto"
          :options="projectList"
          class="file-view-project-select"
          label="name"
          :clearable="false"
        >
        </v-select>
      </div>
      <div class="col-6 col-md-6 col-lg-6 col-xl-4 offset-xl-4">
        <div class="input-group my-auto" style="height: 57px">
          <input
            type="text"
            class="form-control border-radius-20"
            v-model="search"
            @input="searchBar"
          />
          <label for="sizeOptions" class="input-group-text border-radius-20"
            ><font-awesome-icon
              class="my-auto"
              :icon="['fas', 'magnifying-glass']"
          /></label>
        </div>
      </div>
    </div>
    <div v-if="filesBreadcrumb && !search" class="row mb-3">
      <div class="col-12">
        <div
          :class="`bg-${getColorMode.background} text-${getColorMode.text} border-${getColorMode.globalBackground} border-radius-20 p-4`"
        >
          <span
            v-for="(breadcrumbItem, index) in filesBreadcrumb"
            :key="`breadcrumb-${index}`"
          >
            <span
              v-if="breadcrumbItem.id === 0"
              class="breadcrumb-item breadcrumb-home my-auto"
              :class="{
                'filebreadcrumb-item cursor-pointer':
                  filesBreadcrumb.length > 1,
              }"
              @click="
                backToHome(),
                  (filesBreadcrumb = [{ id: 0, name: 'Home' }]),
                  (selectedFolder = null),
                  (folderViewSelectedItem = null)
              "
            >
              <font-awesome-icon :icon="['fal', 'home-alt']" />
            </span>
            <span
              v-else
              @click="
                selectedFolder != breadcrumbItem.id
                  ? backToFolder(dataId, breadcrumbItem.id)
                  : false
              "
              :class="{
                'cursor-pointer filebreadcrumb-item':
                  selectedFolder != breadcrumbItem.id,
              }"
            >
              {{ breadcrumbItem.name + " " }}
            </span>
            <span v-if="index !== filesBreadcrumb.length - 1"> > </span>
          </span>
        </div>
      </div>
    </div>
    <div
      v-if="(selectedFolder || folderViewSelectedItem || multipleSelectedFolders) && !search"
      class="row mb-3"
    >
      <div class="col-12">
        <div
          :class="`bg-${getColorMode.background} text-${getColorMode.text} border-${getColorMode.globalBackground} border-radius-20 p-3`"
        >
          <Popper
            v-if="selectedFolder"
            content="Volver a carpeta anterior"
            placement="top"
            hover
            arrow
          >
            <button
              class="menu-button"
              :disabled="loading"
              @click="
                filesBreadcrumb.length > 2
                  ? (backToFolder(
                      dataId,
                      filesBreadcrumb[filesBreadcrumb.length - 2].id
                    ),
                    (folderViewSelectedItem = null))
                  : (backToHome(),
                    (filesBreadcrumb = [{ id: 0, name: 'Home' }]),
                    (selectedFolder = null),
                    (folderViewSelectedItem = null))
              "
            >
              <div class="text-center">
                <font-awesome-icon :icon="['fas', 'left']" />
              </div>
            </button>
          </Popper>
          <Popper
            v-if="selectedFolder"
            content="Agregar Archivo"
            placement="top"
            hover
            arrow
          >
            <button class="menu-button ms-3" @click="newFile">
              <div class="text-center">
                <font-awesome-icon :icon="['fas', 'file-plus']" />
              </div>
            </button>
          </Popper>
          <Popper
            v-if="multipleFolderDownload"
            :content="multipleFolderDownload.length > 1 ? 'Descargar Carpetas' : 'Descargar Carpeta'"
            placement="top"
            hover
            arrow
          >
            <button class="menu-button ms-3" @click="downloadSelectedFolders">
              <div class="text-center">
                <font-awesome-icon :icon="['fas', 'file-arrow-down']" />
              </div>
            </button>
          </Popper>
          <Popper
            v-if="selectedFolder && folderViewSelectedItem"
            content="Eliminar Archivo Seleccionado"
            placement="top"
            hover
            arrow
          >
            <button
              class="menu-button ms-3"
              @click="deleteFile(folderViewSelectedItem)"
            >
              <div class="text-center">
                <font-awesome-icon :icon="['fas', 'trash-can']" />
              </div>
            </button>
          </Popper>
        </div>
      </div>
    </div>
    <div class="row">
      <div :class="file && (viewFilesOnTree || !file.id) ? 'col-7' : 'col-12'">
        <div
        :class="`p-4 bg-${getColorMode.background} text-${getColorMode.text} border-${getColorMode.globalBackground} border-radius-20 shadow-table p-3 position-relative`"
        >
          <!-- Change view style. Temporarily disabled -->
          <!-- <div class="text-center">
            <div class="btn-group btn-block my-4" role="group" aria-label="Basic radio toggle button group">
              <input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off" checked @click="viewFilesOnTree = true">
              <label class="btn btn-outline-primary" for="btnradio1">Ver archivos en árbol</label>
              <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off" @click="viewFilesOnTree = false">
              <label class="btn btn-outline-primary" for="btnradio2">Ver archivos en lista</label>
            </div>
          </div> -->

          <Loading v-if="loading" text="Cargando"/> 
          <FolderView
            v-if="folders"
            ref="folderView"
            :items="getFolders"
            :key="componentKey"
            :project-id="dataId"
            :file-previsualization="file && (viewFilesOnTree || !file.id)"
            :search-term="search"
            :page="page"
            :size="size"
            @set-data="setData"
            @set-folder="setFolder"
            @set-breadcrumb="setFilesBreadcrumb"
            @set-file="setFile"
            @handleDeleteFileButton="handleDeleteFileButton"
            @folderViewSelectedItem="handleFolderViewSelectedItem"
            @multipleFolderDownload="handleMultipleFolderDownload"
            @handle-loading="handleLoading"
          ></FolderView>
          <div class="row mt-4" v-if="false">
            <div class="col-sm-6 d-flex justify-content-start my-auto">
              <div>
                <span class="items-per-page-text mb-0">Items por página:</span>
                <select
                  id="sizeOptions"
                  v-model="size"
                  class="border-secondary mx-2"
                  aria-label="Default select example"
                  @change="changeSize()"
                >
                  <option
                    v-for="(value, key) in sizeOptions"
                    v-bind:key="`size-select-${key}`"
                  >
                    {{ value }}
                  </option>
                </select>
              </div>
              <p class="table-entries-text mb-0 text-left">
                {{ calcSize }} registros de {{ total }}
              </p>
            </div>
            <div class="col-sm-6">
              <nav aria-label="Paginación">
                <ul class="pagination justify-content-end">
                  <span class="mx-4 my-auto items-per-page-text"
                    >Página {{ page }} de {{ lastPage }}</span
                  >
                  <template v-if="page > 1">
                    <li class="page-item">
                      <a class="page-link" href="javascript:;" @click="page = 1"
                        ><font-awesome-icon :icon="['fal', 'chevrons-left']"
                      /></a>
                    </li>
                    <li class="page-item" aria-current="page">
                      <a
                        href="javascript:;"
                        class="page-link"
                        @click="page = page - 1"
                        ><font-awesome-icon :icon="['fal', 'chevron-left']"
                      /></a>
                    </li>
                  </template>
                  <template v-else>
                    <li class="page-item disabled">
                      <a
                        class="page-link"
                        href="javascript:;"
                        tabindex="-1"
                        aria-disabled="true"
                        ><font-awesome-icon :icon="['fal', 'chevrons-left']"
                      /></a>
                    </li>
                    <li class="page-item disabled">
                      <a
                        class="page-link"
                        href="javascript:;"
                        tabindex="-1"
                        aria-disabled="true"
                        ><font-awesome-icon :icon="['fal', 'chevron-left']"
                      /></a>
                    </li>
                  </template>
                  <li class="page-item active" aria-current="page">
                    <span class="page-link">{{ page }}</span>
                  </li>
                  <template v-if="page < lastPage">
                    <li class="page-item" aria-current="page">
                      <a
                        href="javascript:;"
                        class="page-link"
                        @click="page = page + 1"
                        ><font-awesome-icon :icon="['fal', 'chevron-right']"
                      /></a>
                    </li>
                    <li class="page-item">
                      <a
                        class="page-link"
                        href="javascript:;"
                        @click="page = lastPage"
                        ><font-awesome-icon :icon="['fal', 'chevrons-right']"
                      /></a>
                    </li>
                  </template>
                  <template v-else>
                    <li class="page-item disabled">
                      <a
                        class="page-link"
                        href="javascript:;"
                        tabindex="-1"
                        aria-disabled="true"
                        ><font-awesome-icon :icon="['fal', 'chevron-right']"
                      /></a>
                    </li>
                    <li class="page-item disabled">
                      <a
                        class="page-link"
                        href="javascript:;"
                        tabindex="-1"
                        aria-disabled="true"
                        ><font-awesome-icon :icon="['fal', 'chevrons-right']"
                      /></a>
                    </li>
                  </template>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div :class="file && (viewFilesOnTree || !file.id) ? 'col-5' : 'col'">
        <template v-if="!viewFilesOnTree">
          <div
            :class="`bg-${getColorMode.background} text-${getColorMode.text} border-${getColorMode.globalBackground} border-radius-20 p-4 w-100 sticky-top`"
            v-if="selectedFolder"
          >
            <Loading v-if="loading" />
            <div v-if="selectedFolder.files">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="selectAllFiles"
                  v-model="selectAll"
                />
                <label class="form-check-label" for="selectAllFiles">
                  Seleccionar todo
                </label>
              </div>
              <div class="dropdown">
                <button
                  class="btn btn-secondary dropdown-toggle"
                  type="button"
                  id="dropdownActions"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Acciones en lote
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownActions">
                  <li>
                    <a
                      href="javascript:;"
                      class="dropdown-item"
                      @click="downloadSelectedFiles()"
                      >Descargar</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:;"
                      class="dropdown-item"
                      @click="deleteSelectedFiles()"
                      >Eliminar</a
                    >
                  </li>
                </ul>
              </div>
              <table
                :class="`table table-${getColorMode.background} table-condensed`"
              >
                <thead>
                  <tr>
                    <th colspan="2" scope="col" class="text-center h6">
                      Archivos de la carpeta {{ selectedFolder.name }}
                    </th>
                  </tr>
                  <tr>
                    <th scope="col">Nombre</th>
                    <th scope="col">Ver</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(file, key) in selectedFolder.files"
                    :key="`file${file.id}${key}`"
                  >
                    <td class="align-middle">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :id="`selectedFile${key}`"
                          :value="file"
                          v-model="file.selected"
                        />
                        <label
                          class="form-check-label"
                          :for="`selectedFile${key}`"
                        >
                          {{ file.name }}
                        </label>
                      </div>
                    </td>
                    <td class="align-middle">
                      <Popper
                        class="btn btn-primary btn-sm px-3 m-0 border-0"
                        content="Ver"
                        placement="top"
                        hover
                        arrow
                        @click="viewFile(file), setFolder(file)"
                      >
                        <font-awesome-icon :icon="['fas', 'eye']" />
                      </Popper>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>
        <template v-if="file && (viewFilesOnTree || !file.id)">
          <div
            :class="`bg-${getColorMode.background} text-${getColorMode.text} border-${getColorMode.globalBackground} border-radius-20 p-4 w-100 sticky-top`"
          >
            <div v-if="editDisabled">
              <Loading v-if="loading" />
              <div class="text-end">
                <button
                  type="button"
                  class="btn-close"
                  @click="file = null"
                ></button>
              </div>
              <h4 class="file-view-title">Visualización archivo</h4>
              <div class="row mt-3">
                <div class="col-4">
                  <div
                    class="d-flex justify-content-center align-items-center file-view-image-container w-100 h-100 cursor-pointer"
                    @click="modalFileViewer = true"
                  >
                    <img
                      v-if="
                        file.extension === 'jpg' ||
                        file.extension === 'png' ||
                        file.extension === 'jpeg'
                      "
                      class="w-100 h-100 file-view-image"
                      :src="file.url"
                      alt=""
                    />
                    <font-awesome-icon
                      v-else
                      :icon="['fal', setIcon(file)]"
                      :class="[setIconColor(file), 'file-view-icon']"
                      size="lg"
                    />
                  </div>
                </div>
                <div class="col-8 d-flex flex-column">
                  <p class="file-view-item">
                    Nombre:
                    <span class="file-view-item-name">{{
                      file.id ? file.name : "Cargar archivo"
                    }}</span>
                  </p>
                  <p class="file-view-item">
                    Versión:
                    <span class="file-view-item-name">{{ file.version }}</span>
                  </p>
                  <p class="file-view-item">
                    Fecha de carga:
                    <span class="file-view-item-name">{{
                      formatUploadDate(file.created_at)
                    }}</span>
                  </p>
                  <p class="file-view-item">
                    Extensión:
                    <span class="file-view-item-name">{{
                      file.extension
                    }}</span>
                  </p>
                  <p class="file-view-item">
                    Ubicación:
                    <span class="file-view-item-name">{{
                      folder && folder[0].complete_name
                        ? folder[0].complete_name
                        : "Cargando..."
                    }}</span>
                  </p>
                </div>
              </div>
              <div class="row justify-content-center" v-if="file.id">
                <div class="row" v-if="file.id">
                  <div class="my-4 px-0">
                    <div
                      class="d-flex justify-content-center w-100 file-view-buttons-background px-1 py-1"
                      role="group"
                    >
                      <Popper
                        class="btn btn-primary m-0 border-0"
                        content="Ver"
                        placement="top"
                        hover
                        arrow
                        @click="modalFileViewer = true"
                      >
                        <font-awesome-icon :icon="['fas', 'eye']" />
                      </Popper>
                      <a
                        class="btn btn-primary"
                        :href="file.url"
                        target="_blank"
                      >
                        <Popper
                          class="m-0 border-0"
                          content="Descargar"
                          placement="top"
                          hover
                          arrow
                        >
                          <font-awesome-icon
                            :icon="['fas', 'cloud-arrow-down']"
                          />
                        </Popper>
                      </a>
                      <Popper
                        class="btn btn-primary m-0 border-0"
                        content="Compartir"
                        placement="top"
                        hover
                        arrow
                        @click="modalFileShare = true"
                      >
                        <font-awesome-icon :icon="['fas', 'share']" />
                      </Popper>
                      <!-- <Popper
                      class="btn btn-primary m-0 border-0"
                      content="Versiones"
                      placement="top"
                      hover
                      arrow
                      @click="modalFileVersion = true"
                    >
                      <font-awesome-icon :icon="['fas', 'rectangle-history']" />
                    </Popper> -->
                      <Popper
                        class="btn btn-primary m-0 border-0"
                        content="Comentarios"
                        placement="top"
                        hover
                        arrow
                        @click="modalFileComment = true"
                      >
                        <font-awesome-icon :icon="['fas', 'comments']" />
                      </Popper>
                      <!-- <Popper
                      class="btn btn-primary m-0 border-0"
                      content="Historial"
                      placement="top"
                      hover
                      arrow
                      @click="true"
                    >
                      <font-awesome-icon :icon="['fas', 'clock-rotate-left']" />
                    </Popper> -->
                      <Popper
                        class="btn btn-primary m-0 border-0"
                        content="Transformar"
                        placement="top"
                        hover
                        arrow
                        @click="modalFileConversion = true"
                      >
                        <font-awesome-icon :icon="['fas', 'icons']" />
                      </Popper>
                      <Popper
                        class="btn btn-primary m-0 border-0"
                        content="Eliminar"
                        placement="top"
                        hover
                        arrow
                        @click="deleteFile(file)"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-can']" />
                      </Popper>
                    </div>
                  </div>
                </div>
              </div>
              <ul
                :class="`nav nav-tabs nav-tabs-${getColorMode.background}`"
                id="myTab"
                role="tablist"
              >
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link active"
                    id="versions-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#versions"
                    type="button"
                    role="tab"
                    aria-controls="versions"
                    aria-selected="false"
                  >
                    Versiones
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="conversion-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#conversions"
                    type="button"
                    role="tab"
                    aria-controls="conversions"
                    aria-selected="false"
                  >
                    Conversiones
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="conversion-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#security"
                    type="button"
                    role="tab"
                    aria-controls="security"
                    aria-selected="false"
                  >
                    Seguridad
                  </button>
                </li>
              </ul>
              <div class="tab-content" id="myTabContent">
                <div
                  class="tab-pane fade show active"
                  id="versions"
                  role="tabpanel"
                  aria-labelledby="versions-tab"
                >
                  <table
                    :class="`table table-${getColorMode.background} fs-small mb-0 table-condensed`"
                  >
                    <thead>
                      <tr>
                        <th scope="col">Nombre Versión</th>
                        <th scope="col" class="d-flex justify-content-end">
                          Visualizar
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="version in versions"
                        v-bind:key="version.id"
                        :class="{
                          'bg-light': version.id == selectedVersion.id,
                        }"
                      >
                        <td class="align-middle">
                          {{ version.version
                          }}<span v-if="version.id == versions[0].id">*</span>
                        </td>
                        <td class="align-middle d-flex justify-content-end">
                          <Popper
                            class="btn btn-primary btn-sm px-3 m-0 border-0"
                            content="Ver"
                            placement="top"
                            hover
                            arrow
                            @click="file = version"
                          >
                            <font-awesome-icon :icon="['fas', 'eye']" />
                          </Popper>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <small class="text-muted fst-italic fs-small fw-bold"
                    >*Versión actual</small
                  >
                </div>
                <div
                  class="tab-pane fade"
                  id="conversions"
                  role="tabpanel"
                  aria-labelledby="folders-tab"
                >
                  <table
                    v-if="hasConversions"
                    :class="`table table-${getColorMode.background} fs-small mb-0 table-condensed`"
                  >
                    <thead>
                      <tr>
                        <th colspan="2" scope="col" class="text-center h6">
                          Conversiones
                        </th>
                      </tr>
                      <tr>
                        <th scope="col">Extensión</th>
                        <th scope="col">Ver</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="conversion in file.conversions"
                        v-bind:key="conversion.id"
                      >
                        <td class="align-middle">
                          {{ conversion.extension }}
                        </td>
                        <td class="align-middle">
                          <a
                            class="btn btn-primary <"
                            :href="conversion.url"
                            target="_blank"
                          >
                            <Popper
                              class="m-0 border-0"
                              content="Descargar"
                              placement="top"
                              hover
                              arrow
                            >
                              <font-awesome-icon
                                :icon="['fas', 'cloud-arrow-down']"
                              />
                            </Popper>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-else>
                    <p class="text-center text-muted m-5">
                      No hay conversiones para esta versión.
                    </p>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="security"
                  role="tabpanel"
                  aria-labelledby="folders-tab"
                >
                  <div v-if="hasScans">
                    <table
                      v-for="scan in file.scans"
                      v-bind:key="scan.id"
                      :class="`table table-${getColorMode.background} fs-small mb-0 table-condensed`"
                    >
                      <tbody>
                        <tr>
                          <td class="align-middle">Inofensivo</td>
                          <td class="align-middle">{{ scan.harmless }}</td>
                        </tr>
                        <tr>
                          <td class="align-middle">Malicioso</td>
                          <td class="align-middle">{{ scan.malicious }}</td>
                        </tr>
                        <tr>
                          <td class="align-middle">MD5</td>
                          <td class="align-middle">{{ scan.md5 }}</td>
                        </tr>
                        <tr>
                          <td class="align-middle">Sha256</td>
                          <td class="align-middle">{{ scan.sha256 }}</td>
                        </tr>
                        <tr>
                          <td class="align-middle">Sha1</td>
                          <td class="align-middle">{{ scan.sha1 }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-else>
                    <p class="text-center text-muted m-5">
                      No hay escaneos para esta versión.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="form-floating text-dark my-3" v-if="file.id">
              <input
                v-model="file.newName"
                type="text"
                class="form-control border-secondary"
                :disabled="editDisabled"
              />
              <label for="itemNewName">Nombre</label>
            </div>
            <div class="form-floating text-dark my-3">
              <v-select
                v-model="file.newFolderId"
                :reduce="(folder) => folder.id"
                class="form-select border-secondary"
                aria-label="Seleccionar Ubicación"
                :options="folderList"
                label="complete_name"
                :clearable="false"
                :disabled="editDisabled"
              >
                <template #option="{ complete_name }">
                  {{ form.name }}/{{ complete_name }}
                </template>
                <template #selected-option="{ complete_name }">
                  {{ form.name }}/{{ complete_name }}
                </template>
              </v-select>
              <label for="itemParent">Seleccionar Ubicación</label>
            </div> -->
            <div v-if="!editDisabled">
              <div class="text-end">
                <button
                  type="button"
                  class="btn-close"
                  @click="(editDisabled = true), (file = null)"
                ></button>
              </div>
              <!-- <div class="form-floating text-dark my-3">
                <v-select
                  v-model="file.newFolderId"
                  :reduce="(folder) => folder.id"
                  class="form-select"
                  aria-label="Seleccionar Ubicación"
                  :options="folderList"
                  label="complete_name"
                  :clearable="false"
                  :disabled="editDisabled"
                >
                  <template #option="{ complete_name }">
                    {{ form.name }}/{{ complete_name }}
                  </template>
                  <template #selected-option="{ complete_name }">
                    {{ form.name }}/{{ complete_name }}
                  </template>
                </v-select>
                <label for="itemParent">Seleccionar Ubicación</label>
              </div> -->
            </div>
            <div class="" v-if="!editDisabled">
              <h3 class="mb-3">Agregar Archivo</h3>
              <div
                class="p-2 rounded drag-container text-dark"
                @dragover.prevent
                @drop.prevent
              >
                <div
                  class="drag-file rounded text-center d-flex flex-column justify-content-center align-items-center px-3 py-5"
                  @drop="dragFile"
                >
                  <div
                    class="w-100 py-5 break-word drag-file-text-success"
                    v-if="file.newName"
                  >
                    <h4>{{ file.newName }}</h4>
                    <p class="mt-4">
                      Si te equivocaste, puedes arrastrar otro archivo sin
                      problema
                      <br />
                      o
                      <br />
                      <button class="btn-select-file py-2" @click="selectFile">
                        Seleccionar Nuevo Archivo
                      </button>
                    </p>
                  </div>
                  <p class="py-5 drag-file-text" v-else>
                    Arrastrar y soltar tu archivo aquí
                    <br />
                    o
                    <br />
                    <button class="btn-select-file" @click="selectFile">
                      Seleccionar Archivo
                    </button>
                  </p>
                </div>
                <input
                  id="fileFile"
                  ref="fileFile"
                  type="file"
                  style="display: none"
                  @change="handleFileUpload($event)"
                />
              </div>
              <div class="mt-4">
                <input
                  v-model="hasExpiration"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckDefault"
                />
                <label
                  class="form-check-label px-3"
                  for="flexSwitchCheckDefault"
                  >¿Posee Fecha de Expiración?</label
                >
              </div>
            </div>
            <DateField
              v-if="hasExpiration || file.expiration_date"
              :disabled="editDisabled"
              :model="file.newExpirationDate"
              @update-field="setDate"
            />
            <div class="d-flex justify-content-end">
              <button
                type="button"
                @click="saveFile()"
                class="btn btn-add-file"
                v-if="!editDisabled && file.newName"
              >
                + Agregar
              </button>
            </div>
          </div>
        </template>
      </div>
    </div>
    <FileVersion
      @close-modal="modalFileVersion = false"
      :projectId="dataId"
      :fileId="file.id"
      :folderId="file.folder_id"
      v-if="modalFileVersion"
    />
    <FileComment
      @close-modal="modalFileComment = false"
      :projectId="dataId"
      :fileId="file.id"
      :folderId="file.folder_id"
      v-if="modalFileComment"
      :file-name="file.name"
    />
    <FileViewer
      @close-modal="modalFileViewer = false"
      :projectId="dataId"
      :fileId="file.id"
      :folderId="file.folder_id"
      v-if="modalFileViewer"
    />
    <FileShare
      @close-modal="modalFileShare = false"
      :projectId="dataId"
      :fileId="file.id"
      :folderId="file.folder_id"
      v-if="modalFileShare"
    />
    <FileConversion
      @close-modal="modalFileConversion = false"
      :projectId="dataId"
      :fileId="file.id"
      :folderId="file.folder_id"
      v-if="modalFileConversion"
    />
  </div>
  <ModalFile v-if="showModal" @close-modal="showModal = false" modalType="error" modalTitle="Archivo no permitido"
    :modalText="errorMessage">
  </ModalFile>
</template>
<script>
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import Loading from "@/components/Loading.vue";
import FileVersion from "@/components/FileVersions.vue";
import FileComment from "@/components/FileComments.vue";
import FileViewer from "@/components/FileViewer.vue";
import FileShare from "@/components/FileShare.vue";
import FileConversion from "@/components/FileConversion.vue";
import DateField from "@/components/form/DateField.vue";
import FolderView from "@/components/FolderViewList.vue";
import ModalFile from '@/components/ModalFile.vue';

export default {
  name: "file-index",
  emits: ["setBreadcrumb"],
  components: {
    Loading,
    FileVersion,
    FileComment,
    FileViewer,
    FileShare,
    FileConversion,
    DateField,
    FolderView,
    ModalFile
  },
  data() {
    return {
      filesBreadcrumb: [{ id: 0, name: "Home" }],
      breadcrumb: [{ text: "Archivos", link: { name: "files" } }],
      form: { name: null, description: null },
      folders: [],
      foldersCopy: [],
      folderList: [],
      projectList: [],
      componentKey: 0,
      dataId: null,
      file: null,
      selectedFolder: null,
      editDisabled: true,
      modalFileVersion: false,
      modalFileComment: false,
      modalFileViewer: false,
      modalFileShare: false,
      modalFileConversion: false,
      showUpload: false,
      loading: false,
      viewFilesOnTree: true,
      selectAll: false,
      hasExpiration: false,
      search: null,
      results: null,
      versions: [],
      selectedVersion: null,
      folder: null,
      showDeleteFileButton: false,
      folderViewSelectedItem: null,
      multipleFolderDownload: null,
      multipleSelectedFolders: false,
      controller: null,
      sizeOptions: [10, 25, 50, 100],
      page: 1,
      size: 10,
      total: 0,
      showModal: false,
      showModalZip: false,
      errorMessage: "No se permite este formato",

      showErrorMessage: false
    };
  },
  created() {
    this.$emit("setBreadcrumb", this.breadcrumb);
    this.setProjects();
  },
  methods: {
    ...mapMutations("general", ["setOpenedFolders"]),
    handleMultipleFolderDownload(item) {
      this.multipleFolderDownload = item
      item.length > 0 ? this.multipleSelectedFolders = true : null
    },
    handleFolderViewSelectedItem(item) {
      this.folderViewSelectedItem = item;
    },
    handleDeleteFileButton(value) {
      this.showDeleteFileButton = value;
    },
    viewFile(file) {
      this.file = file;
      this.modalFileViewer = true;
    },
    backToFolder(projectId, folderId) {
      this.$refs.folderView.showFolder(projectId, folderId);
    },
    deleteFile(file) {
      this.$swal({
        title: "¿Estás seguro?",
        text: "Eliminaras el documento con esta acción!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "¡Si, borrar!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;
          this.axios
            .delete(
              `projects/${this.dataId}/folders/${file.folder_id}/files/${file.id}`
            )
            .then(() => {
              this.loading = false;
              this.$swal({
                icon: "success",
                title: "Archivo borrado con éxito",
              });
              this.setData();
              this.folderViewSelectedItem = null;
            })
            .catch((error) => {
              console.log(error);
              this.loading = false;
            });
        }
      });
      this.filesBreadcrumb = [{ id: 0, name: "Home" }];
      this.selectedFolder = null;
      this.folderViewSelectedItem = null;
    },
    handleLoading(value) {
      console.log(value);
      console.log("handling");
      this.loading = value;
    },
    formatUploadDate(uploadDate) {
      const dateObject = new Date(uploadDate);
      return `${dateObject.getUTCDate()}-${
        dateObject.getUTCMonth() + 1
      }-${dateObject.getUTCFullYear()} ${String(
        dateObject.getUTCHours()
      ).padStart(2, "0")}:${String(dateObject.getUTCMinutes()).padStart(
        2,
        "0"
      )}`;
    },
    downloadSelectedFolders(){
      this.loading = true
      let folderIds = this.multipleFolderDownload
      this.axios
        .post(
          `projects/${this.dataId}/folders/${folderIds[0]}/files/massive_folders_download`,
          { folder_ids: folderIds }
        )
        .then((result) => {
          this.loading = false
          this.$swal({
              icon: "success",
              title: result.data.msg,
              text: "",
            })
        })
        .catch((error) => {
          this.loading = false
          this.$swal({
              icon: "error",
              title: "Ops! hubo un error cargando el archivo, por favor inténtalo más tarde.",
            });
          console.log(error);
        });
    },
    downloadSelectedFiles() {
      let files = [];
      this.selectedFolder.files
        .filter((file) => file.selected)
        .map((file) => {
          files.push(file);
        });
      this.axios
        .post(
          `projects/${this.dataId}/folders/${this.selectedFolder.id}/files/massive_download`,
          { files: files }
        )
        .then((result) => {
          window.open(result.data.body);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deleteSelectedFiles() {
      let count = 0;
      this.$swal({
        title: "¿Estás seguro?",
        text: "Eliminaras los documentos con esta acción!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "¡Si, borrar!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;
          this.selectedFolder.files
            .filter((file) => file.selected)
            .map((file) => {
              count = count + 1;
              this.axios
                .delete(
                  `projects/${this.dataId}/folders/${this.selectedFolder.id}/files/${file.id}`
                )
                .then(() => {
                  this.loading = false;
                  if (
                    count ==
                    this.selectedFolder.files.filter((file) => file.selected)
                      .length
                  ) {
                    this.$swal({
                      icon: "success",
                      title: "Archivo borrado con éxito",
                    });
                    this.setData();
                  }
                })
                .catch((error) => {
                  console.log(error);
                  this.loading = false;
                });
            });
        }
      });
    },
    backToHome() {
      this.setData();
      this.$refs.folderView.setTableItems();
    },
    setProjects() {
      let app = this;
      this.file = null;
      this.axios
        .get(`projects`)
        .then((result) => {
          app.projectList = result.data.body.data;
          app.dataId = app.projectList[0].id;
          app.setData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setData() {
      let app = this;
      this.file = null;
      this.loading = true;
      this.axios
        .get(`projects`)
        .then((result) => {
          this.loading = false;
          app.projectList = result.data.body.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
      this.axios
        .get(
          `projects/${this.dataId}/get_folders_without_files?size=${this.size}&page=${this.page}`
        )
        .then((result) => {
          app.form = result.data.body;
          app.folders = [app.form];
          app.foldersCopy = [app.form];
          app.componentKey += 1;
        })
        .catch((error) => {
          console.log(error);
        });
      // this.axios
      //   .get(`projects/${this.dataId}/list_folders`)
      //   .then((result) => {
      //     app.folderList = [{ id: null, complete_name: "" }];
      //     app.folderList = app.folderList.concat(result.data.body);
      //     app.componentKey += 1;
      //     if (app.selectedFolder) {
      //       if (app.selectedFolder.id)
      //         app.selectedFolder = app.folderList.filter(
      //           (folder) => app.selectedFolder.id == folder.id
      //         );
      //     }
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
    },
    newFile() {
      this.file = null;
      this.setFile({ name: null, folder_id: this.selectedFolder });
    },
    async setFile(item) {
      this.file = item;
      this.file.newName = this.file.name;
      this.file.newExpirationDate = this.file.expiration_date;
      this.file.newFolderId = this.file.folder_id;
      this.editDisabled = this.file.id ? true : false;
      this.hasExpiration = false;
      if (item.id) {
        const versionsResponse = await this.axios.get(
          `projects/${this.dataId}/folders/${item.folder_id}/files/${item.id}/versions`
        );
        this.versions = await versionsResponse.data.body;
        this.selectedVersion = versionsResponse.data.body[0];
        this.axios
          .get(`projects/${this.dataId}/folders/${item.folder_id}`)
          .then((result) => {
            this.folder = result.data.body;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        if (this.$refs.fileFile.value != null) this.$refs.fileFile.value = null;
      }
    },
    setFolder(item) {
      this.search = "";
      this.selectedFolder = item;
      this.file = null;
    },
    setFilesBreadcrumb(obj, breadcrumb = []) {
      // Si el objeto tiene parent_folder
      if (obj.parent_folder) {
        // Agregar el objeto actual al breadcrumb
        breadcrumb.push({
          id: obj.id,
          name: obj.name,
        });
        // Llamar recursivamente a la función con el parent_folder
        return this.setFilesBreadcrumb(obj.parent_folder, breadcrumb);
      } else {
        breadcrumb.push({
          id: 0,
          name: "Home",
        });
      }
      this.filesBreadcrumb = breadcrumb.reverse(); // Revertir el array para que quede en el orden correcto
    },
    saveFile() {
      if (this.file.newFile) {
        this.loading = true;
        let saveData = new FormData();
        saveData.append("folder_file[file]", this.file.newFile);
        if (this.hasExpiration)
          saveData.append(
            "folder_file[expiration_date]",
            this.file.newExpirationDate
          );
        let app = this;
        this.axios
          .post(
            `projects/${this.dataId}/folders/${this.file.newFolderId}/files`,
            saveData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((result) => {
            app.file = null;
            app.loading = false;
            app.showUpload = false;
            this.$swal({
              icon: "success",
              title: "Éxito",
              text: result.data.msg,
            });
            app.form = result.data.body;
            app.folders = [app.form];
            app.foldersCopy = [app.form];
            app.componentKey += 1;
          })
          .catch((error) => {
            console.log(error);
            app.loading = false;
            this.$swal({
              icon: "error",
              title:
                "Ops! hubo un error cargando el archivo, favor intenta más tarde",
            });
          });
      }
    },
    selectFile() {
      this.$refs.fileFile.click();
    },
    handleFileUpload(event) {
      const uploadedFile = event.target.files[0];
      if (uploadedFile.name.toLowerCase().endsWith('.rar')) {
        this.showModal = true;
        event.target.value = '';
      } else {
        this.file.newName = uploadedFile.name;
        this.file.newFile = uploadedFile;
      }
    },
    dragFile(event) {
      const uploadedFile = event.dataTransfer.files[0];
      if (uploadedFile.name.toLowerCase().endsWith('.rar')) {
        this.showModal = true;
        event.target.value = '';
      } else {
        this.file.newName = uploadedFile.name;
        this.file.newFile = uploadedFile;
      }
    },
    setDate(item) {
      this.file.newExpirationDate = item;
    },
    searchData() {
      let regex = new RegExp(`.*?${this.search}`, "i");
      this.results = {
        id: 0,
        name: "Resultados de la búsqueda",
        state: "active",
        description: "",
        is_hidden: false,
        children: [],
        files: [],
      };
      this.folders = [this.filteredData(this.foldersCopy, regex)];
      if (!this.search) this.folders = this.foldersCopy;
      this.componentKey += 1;
    },
    searchBar() {
      this.filesBreadcrumb = [{ id: 0, name: "Home" }];
      this.selectedFolder = null;
      this.folderViewSelectedItem = null;
      this.file = null;
      let app = this;
      if (app.controller == null) app.controller = new AbortController(); // If this is the very first requests, creates a new abort controller
      if (app.controller && app.controller.signal.aborted)
        // Check wether there's a previoues request being executed
        app.controller = new AbortController(); // If aborted, creates a new abort controller and signal
      let signal = app.controller.signal; // asign the new signal to the var so it can handle the abort

      if (app.search) {
        if (app.signal) app.controller.abort(); // cancel the request
        this.axios
          .get(`folder_structures/${this.dataId}/search_bar`, {
            params: {
              search: app.search,
              page: this.page,
              per_page: this.perPage,
            },
            signal,
          })
          .then((result) => {
            app.form = result.data.body;
            app.folders = [app.form];
            app.foldersCopy = [app.form];
            app.componentKey += 1;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        app.setData();
      }
    },
    filteredData(data, regex) {
      if (!data || !data.length) return [];

      let filter;

      for (let i = 0; i < data.length; i++) {
        if (!data[i].files) data[i]["files"] = [];

        filter = data[i].files.filter((el) => regex.test(el.name));

        if (filter.length) this.results.files.push(...filter);

        filter = this.filteredData(data[i].children, regex);

        if (filter.length) this.results.files.push(...filter);
      }

      return this.results;
    },
    setIcon(item) {
      if (["jgp", "svg", "png"].includes(item.extension)) {
        return "file-image";
      } else if (["doc", "docx"].includes(item.extension)) {
        return "file-word";
      } else if (["xml"].includes(item.extension)) {
        return "file-spreadsheet";
      } else if (["dwg", "pdf"].includes(item.extension)) {
        return "file-pdf";
      } else {
        return "file";
      }
    },
    setIconColor(item) {
      if (["jgp", "svg", "png"].includes(item.extension)) {
        return "text-secondary";
      } else if (["doc", "docx"].includes(item.extension)) {
        return "text-word";
      } else if (["xml", "csv"].includes(item.extension)) {
        return "text-success";
      } else if (["dwg", "pdf"].includes(item.extension)) {
        return "text-danger";
      } else {
        return "text-secondary";
      }
    },
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
    getFolders() {
      return this.folders;
    },
    hasConversions() {
      return this.file.conversions ? this.file.conversions.length > 0 : false;
    },
    hasScans() {
      return this.selectedVersion.scans
        ? this.selectedVersion.scans.length > 0
        : false;
    },
    lastPage() {
      return Math.ceil(parseFloat(this.total) / parseFloat(this.size));
    },
    calcSize() {
      return this.total < this.size ? this.total : this.size;
    },
  },
  watch: {
    selectAll: {
      handler: function () {
        this.selectedFolder.files.map(
          (file) => (file.selected = this.selectAll ? true : false)
        );
      },
    },
    hasExpiration: {
      handler: function () {
        this.file.newExpirationDate =
          this.hasExpiration || this.file.expiration_date
            ? this.file.newExpirationDate
            : null;
      },
    },
    dataId: {
      handler: function () {
        this.setData();
        this.filesBreadcrumb = [{ id: 0, name: "Home" }];
        this.selectedFolder = null;
        this.folderViewSelectedItem = null;
        this.search = "";
        this.setOpenedFolders([]);
      },
    },
  },
};
</script>
